<template>
  <div>
    <VAlert v-if="vacanciesList.fetchError || company.fetchError" type="error">
      {{ vacanciesList.fetchError }}
    </VAlert>
    <div v-else-if="vacanciesList.isFetched && company.isFetched">
      <div class="vacancy-list-company">
        <div class="vacancy-list-company__image-wrap">
          <CompanyLogo :logo="company.data.logo" :title="company.data.name" />
        </div>
        <div class="vacancy-list-company__text-wrap">
          <div class="vacancy-list-company__name">
            {{ company.data.name }}
          </div>
          <div class="vacancy-list-company__description">
            {{ vacanciesList.data.description }}
          </div>
          <RouterLink class="vacancy-list-company__link" :to="getCompanyLink()">
            {{ $t('link') }}
          </RouterLink>
        </div>
      </div>
      <CopyLinks :vacancy-list="vacanciesList.data" :company="company.data" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppPreloader from '../AppPreloader.vue';
import CompanyLogo from '../Company/CompanyLogo.vue';
import CopyLinks from './CopyLinks.vue';

export default {
  name: 'MainInfo',
  components: {
    CopyLinks,
    CompanyLogo,
    AppPreloader,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('vacanciesList', ['vacanciesList']),
    ...mapState('company', ['company']),
  },
  watch: {
    vacanciesList(newValue) {
      if (newValue.fetchCode === 404) {
        this.$router.push({ name: '404' });
      }
    },
    company(newValue) {
      if (newValue.fetchCode === 404) {
        this.$router.push({ name: '404' });
      }
    },
  },
  methods: {
    getCompanyLink() {
      return { name: 'company', params: { companyId: this.vacanciesList.data.companyId } };
    },
  },
};
</script>

<style lang="scss" scoped>
.vacancy-list-company {
  display: flex;
  background: #FFFFFF;
  padding: 0.75rem 1.875rem 1.1875rem 0.75rem;
  box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.16);
  border-radius: 0.625rem;
  margin-bottom: 1.25rem;
  &__image-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10.625rem;
    height: 10.625rem;
    padding: 1.125rem;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 0.25rem;
    margin-right: 1.75rem;
    img {
      max-width: 8.375rem;
      min-height: 8.375rem;
    }
  }
  &__text-wrap {
    flex-grow: 2;
    font-weight: 400;
  }
  &__link {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.43;
    color: #0A82D9;
    text-decoration: none;
  }
  &__name {
    font-size: 1.5rem;
    color: #212121;
    margin-bottom: 0.625rem;
  }
  &__description {
    font-size: 0.875rem;
    line-height: 1.43;
    color: #212121;
    margin-bottom: 1.0625rem;
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .vacancy-list-company {
    &__image-wrap {
      width: 10rem;
      height: 10rem;
      padding: 0.9375rem;
      margin-right: 1.625rem;
      img {
        max-width: 8.125rem;
        min-height: 8.125rem;
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .vacancy-list-company {
    padding: 1.125rem 1rem;
    &__image-wrap {
      width: 6rem;
      height: 6rem;
      padding: 0.625rem;
      margin-right: 1rem;
      img {
        max-width: 4.75rem;
        min-height: 4.75rem;
      }
    }
    &__name {
      font-size: 1.25rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .vacancy-list-company {
    display: block;
    &__image-wrap {
      width: 8rem;
      height: 8rem;
      padding: 0.875rem;
      margin: 0 auto 1.25rem;
      img {
        max-width: 6.25rem;
        min-height: 6.25rem;
      }
    }
  }
}
</style>

<i18n lang="yml" locale="ru">
link: Подробнее о компании
</i18n>
<i18n lang="yml" locale="en">
link: About the company
</i18n>
